/** @jsx h */
import { h } from 'preact'

const Placeholder = () => (
  <svg
    class='Avatar Avatar--xsmall Avatar--placeholder'
    xmlns='http://www.w3.org/2000/svg'
    width='48'
    height='48'
    viewBox='0 0 48 48'
    enableBackground='new 0 0 48 48'
    fill='currentColor'
  >
    <path d='M41.5 43l-11.9-3.5s-.4-2-.4-3.2c1.3-.6 4.3-3.6 5.4-8.5.5-2 .6-5.1-.1-8.2-.1-.6-.2-1.2-.4-1.7-.5-1.7-1.3-3.3-2.3-4.6-1.6-2.1-3.8-3.4-6.3-3.6-.2-.1-.9-.1-1.4-.1s-1.2 0-1.4.1c-2.5.3-4.7 1.6-6.3 3.6-1 1.3-1.8 3-2.3 4.6-.2.6-.3 1.2-.4 1.7-.6 3.1-.5 6.1-.1 8.2 1.2 5 4.2 7.9 5.4 8.5 0 1.1-.4 3.2-.4 3.2L6.5 43C3.4 44.9 2 44.5 2 48h44c0-3.5-1.4-3.1-4.5-5z' />
  </svg>
)

export default Placeholder
